import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useEducationForm } from '@modules/staff/educationalDegree/hooks/useEducationForm';

export default function EducationForm({ degree, onClose, selectedData, fetchData }) {
    const { t } = useTranslation();
    const {
        modalRef,
        register,
        handleSubmit,
        errors,
        setValue,
        isActiveChecked,
        serverMessage,
        onSubmit
    } = useEducationForm({ degree, onClose, selectedData, fetchData });

    const handleClose = (e) => {
        e.preventDefault();
        onClose();
    };

    return (
        <div className="modal show" tabIndex="-1">
            <div className="modal-dialog" ref={modalRef}>
                <div className="modal-content">
                    <button 
                        type="button" 
                        className="close" 
                        onClick={handleClose}
                        aria-label="Close"
                    >
                        <FontAwesomeIcon icon={faTimes} size="lg" />
                    </button>
                    <div className="modal-body">
                        <h4 className="modal-title">
                            {degree ? t('education.form.edit') : t('education.form.add')}
                        </h4>
                        <form id="educationForm" className="region-form" onSubmit={handleSubmit(onSubmit)}>
                            <div className="form-grid">
                                <div>
                                    <div className="form-group">
                                        <span className="span-bold">
                                            {t('education.form.code')} <span className="required">*</span>
                                        </span>
                                        <input
                                            type="text"
                                            placeholder={t('education.form.code')}
                                            className={`form-control ${errors.code ? 'is-invalid' : ''}`}
                                            {...register('code')}
                                        />
                                        {errors.code && (
                                            <div className="invalid-feedback">{errors.code.message}</div>
                                        )}
                                    </div>

                                    <div className="form-group">
                                        <span className="span-bold">
                                            {t('education.form.education')} <span className="required">*</span>
                                        </span>
                                        <input
                                            type="text"
                                            placeholder={t('education.form.education')}
                                            className={`form-control ${errors.education ? 'is-invalid' : ''}`}
                                            {...register('education')}
                                        />
                                        {errors.education && (
                                            <div className="invalid-feedback">{errors.education.message}</div>
                                        )}
                                    </div>

                                    <div className="form-group">
                                        <span className="span-bold">
                                            {t('education.form.degreeLevel')}
                                        </span>
                                        <input
                                            type="text"
                                            placeholder={t('education.form.degreeLevel')}
                                            className={`form-control ${errors.degreeLevel ? 'is-invalid' : ''}`}
                                            {...register('degreeLevel')}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <div className="form-group">
                                        <span className="span-bold">
                                            {t('education.form.addCode')}
                                        </span>
                                        <input
                                            type="text"
                                            placeholder={t('education.form.addCode')}
                                            className={`form-control ${errors.addCode ? 'is-invalid' : ''}`}
                                            {...register('addCode')}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <span className="span-bold">
                                            {t('education.form.addLevel')}
                                        </span>
                                        <input
                                            type="text"
                                            placeholder={t('education.form.addLevel')}
                                            className={`form-control ${errors.addLevel ? 'is-invalid' : ''}`}
                                            {...register('addLevel')}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <span className="span-bold">
                                            {t('education.form.ordno')}
                                        </span>
                                        <input
                                            placeholder={t('education.form.ordno')}
                                            className={`form-control ${errors.ordno ? 'is-invalid' : ''}`}
                                            {...register('ordno')}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <span className="span-bold">
                                            {t('education.form.isActive')}
                                        </span>
                                        <div className="input-checkbox-wrapper">
                                            <input
                                                type="checkbox"
                                                {...register('active')}
                                                checked={isActiveChecked}
                                                onChange={(e) => {
                                                    const newValue = e.target.checked;
                                                    setValue('active', newValue);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {serverMessage && <div className="error-message">{serverMessage}</div>}
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="submit" form="educationForm" className="btn btn-primary">
                            {t('common.save')}
                        </button>
                        <button type="button" className="form-btn btn-red" onClick={onClose}>
                            {t('common.cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
